<template>
  <div v-if="turnos" class="col-xs-12 col-md-3">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="turnos"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import TurnoService from "../../../../domain/corpore/TurnoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-turno-colegio",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: Number,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    turnos() {
      const turnoService = new TurnoService(this.$http);
      return turnoService
        .getTurnosColegio()
        .then(result => {
          return result.map(turno => ({
            value: turno.CODTURNO,
            text: turno.NOME
          }));
        })
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TurnoColegio.vue